import React, { Component } from 'react'

class FilterFixedInput extends Component {
    render() {
        return (
            <div style={{
                width:300,

                // margin:'5px 0px',
                marginTop:5,marginBottom:5,
                marginRight:16,
                // marginTop:4,
                height:'100%',
                display:'flex',
                flexDirection:'column',
                ...this.props.containerStyle
            }}>
                {this.props.label&&
            <span className='input-label' style={{
                // color:'#333333',
                // fontSize:14
                ...this.props.labelStyle
            }}>{this.props.label}</span>
        }
            {this.props.children}
            </div>
        )
    }
}

export default FilterFixedInput
